var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./EditorsPicksEditDocuments.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-82b183f2\",\"hasScoped\":false}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./EditorsPicksEditDocuments.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/editorsPicks/EditorsPicksEditDocuments.vue
// module id = 744
// module chunks = 0